import React, { useState, useEffect } from 'react';
import DropdownInput from './Dropedownbutton.js';
import TransactionTable from './TransactionTable.js';
import './transactionDetails.css';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import ClipLoader from 'react-spinners/ClipLoader';
import { useTheme } from '@mui/material';

const override = {
  display: "block",
  margin: "10% auto",
  marginLeft: '50%'
};

const TransactionDetail = () => {
  const [summary, setSummary] = useState(false);
  const [transaction, setTransaction] = useState(true);
  const themename = useSelector((state) => state.theme);
  const [transactionData, setTransactionData] = useState(null);
  const [summaryData, setSummaryData] = useState(null);
  const [data, setData] = useState(null);
  const theme = useTheme();
 
  useEffect(() => {
    if (data) {
      // Check if Data has summary and transaction
      
      if (data.summary) {
        setSummaryData(data.summary);
        setTransactionData(data.transaction);
      }
       if (data.transaction) {
        setTransactionData(data.transaction);
        setTransaction(true);
        setSummary(false);
      }
    }
  }, [data]);

  const handleTransaction = () => {
    if (data?.transaction) {
      setTransactionData(data.transaction);
    }
    setTransaction(true);
    setSummary(false);
  };
  return (
    <>
      <ToastContainer />
      <div className="transactionDetails_main" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main  }}>
        <div className="head">
          <div className='transactiondetailhead'>
            <h2 style={{ textAlign : 'center', marginRight: '2vw', color: 'white' }}>Transaction Details</h2>
          </div>
          {
             ( <div className='printbutton'>
              <DropdownInput setData={setData} />
              {/* <BsPrinterFill onClick={printContent} className='printicon' /> */}
            </div> )
          }
         
        </div>
        <div id="transactionDetails_container" className={`transactionDetails_container ${themename === "dark" ? "dark" : "light"}`} style={{ maxWidth: '1200px', margin: '0 auto', padding: '2vw' }}>
          
          {
            (() => {
              if (!data) {
                return (
                  <ClipLoader
                    color={theme.palette.maincolor.light}
                    loading={true}
                    cssOverride={override}
                    size={30}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                );
              }
              if(summary && summaryData != null && summaryData.length > 0) {
                console.log("summary data is ", summaryData);
              }

              if (transactionData != null && transactionData.length > 0) {
                return (
                  <>
                    <div className="tableOptions">
                      <button
                        className={`${transaction ? 'active' : 'fade'}`}
                        onClick={handleTransaction}
                        style={{
                          backgroundColor: theme.palette.background.alt,
                          color: theme.palette.primary.main,
                        }}
                      >
                        Transactions
                      </button>
                    </div>
                    {transactionData && transaction && <TransactionTable data={transactionData} />}
                  </>
                );
              }

              return <div style={{ textAlign: 'center',color:'red' }}>No Data Found</div>;
            })()
          }
        </div>
      </div>
    </>
  );
};

export default TransactionDetail;